import { useReducer } from 'react';


const defaultState = {
  page: 0,
  pageSize: 10,
  count: 0,
  content: [],
}


function reducer(state, action) {
  const p = action.payload
  switch (action.type) {
    case "LOAD_LINES":
      return {...state, page: p.number, count: p.totalElements, content: p.content }
    case "CHANGE_PAGE":
      return {...state, page: p }
    case "CHANGE_PAGE_SIZE":
      return {...state, pageSize: p }
    case "RESET_TABLE":
      return { ...p }
    default:
      return state
  }
}

export const useTableReducer = (initialState) => {
  const [data, dispatch] = useReducer(reducer, { ...defaultState, ...initialState });

  function resetTable() {
    dispatch({ type: 'RESET_TABLE', payload: { ...defaultState, ...initialState } });
  }

  function loadData(data) {
    dispatch({type: "LOAD_LINES", payload: data})
  }

  function changePage(page) {
    dispatch({type: 'CHANGE_PAGE', payload: parseInt(page)})
  }

  function changePageSize(size) {
    dispatch({type: 'CHANGE_PAGE_SIZE', payload: parseInt(size)})
  }

  return [data, { resetTable, loadData, changePage, changePageSize }]
}